import { useEffect, useState } from 'react'

function useLayoutSetter(componentLayout: UseLayoutSetterProps) {
  const [layout, setLayout] = useState('')

  useEffect(() => {
    if (
      (window?.location?.pathname === '/categoria/life' &&
        componentLayout !== 'vivara') ||
      componentLayout === 'life'
    ) {
      setLayout('life')
    } else {
      setLayout('vivara')
    }
  }, [componentLayout])

  return layout
}

export default useLayoutSetter
